import React from "react";
import PropTypes from "prop-types";

export default function MobileDropdown({ links, open }) {
  if (!open) return null;

  return (
    <nav className="giving-nav-mobile-dropdown primary-color-border">
      <ul>
        {links.map((link) => (
          <li key={link.id}>
            <a
              data-testid="t-MobileD-a"
              href={link.url}
              target={link.external ? "_blank" : null}
              rel={link.external ? "noopener noreferrer" : null}>
              {link.text}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}

MobileDropdown.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      external: PropTypes.bool,
    }),
  ).isRequired,
  open: PropTypes.bool.isRequired,
};
